import { useTranslation } from 'react-i18next';

import ProgressBarWithText from 'components/ProgressBarWithText';

interface ProgressCountComponentProps {
    completedCount: number,
    totalCount: number
}

const ProgressCountComponent = ({ completedCount, totalCount }: ProgressCountComponentProps) => {
    const { t } = useTranslation('common');

    if (!totalCount) {
        return null;
    }

    return (
        <div className="progress-wrapper">
            <div className="progress-wrapper-head">
                { t('Progress') }
            </div>

            <ProgressBarWithText value={completedCount} total={totalCount} />
        </div>
    )
}

export default ProgressCountComponent;
